/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TrendInterval = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;
export type TrendInterval = typeof TrendInterval[keyof typeof TrendInterval];

